/* eslint-disable @typescript-eslint/no-explicit-any */
import { Server } from "mock-socket"

export type Request = {
    requestId: string
    action: string
    country: string
    data: any
}
type ResponsePayload = {
    action: string
    type: string
    data: any
}
type RequestResponseMatcher = (request: Request) => ResponsePayload | undefined

export const createWsServer = (requestResponseMatcher: RequestResponseMatcher): Server => {
    const mockServer = new Server("ws://127.0.0.1:3001", { mock: false })

    mockServer.on("connection", (connection) => {
        connection.on("message", (data) => {
            if (typeof data !== "string") throw new Error(`data is not a string, but ${typeof data}`)

            const request = JSON.parse(data)
            // console.log("WS REQUEST", request)

            const responsePayload = requestResponseMatcher(request)
            if (!responsePayload) {
                console.error("UNHANDLED REQUEST", request.action)
            }
            const response = responsePayload ? { ...responsePayload, requestId: request.requestId } : undefined
            // console.log("WS RESPONSE", response)
            connection.send(JSON.stringify(response))
        })
    })
    return mockServer
}

export const stopWsServer = (server: Server | null): void => {
    if (!server) return
    server.stop()
}
